const setValue = function (state, { key, value }) {
    state[key] = value
}

export default {
    setValue,
}
